<template>
  <router-link v-bind="linkProps" v-slot="{ href, navigate, isActive }">
    <li>
      <a :href="href" @click="navigate" class="navlink" :class="[isActive && 'active-navlink']">
        <slot />
        <span class="ml-4">
          {{ linkProps.name }}
        </span>
      </a>
    </li>
  </router-link>
</template>

<script>
export default {
  props: ['linkProps'],
  name: 'VNavLink',
};
</script>
